import { TFunction } from 'i18next'

import { GetMaintenanceAnalyticsResponse } from '@/api/maintenance/get-maintenance-analytics'
import { convertMinutesToDaysHoursMinutes } from '@/helpers/helpers'

export interface MaintenanceDataReportCard {
  title: string
  description: string
  formatValue: (data: GetMaintenanceAnalyticsResponse) => string
}

// Note: convertMinutesToDaysHoursMinutes returns an empty string for exactly 0 minutes (every
// unit is falsy, so nothing gets appended) - falls back to "0m" so a genuinely-instant time
// (e.g. a building with no closed requests yet) renders a value instead of a blank line.
const formatTime = (minutes: number) => convertMinutesToDaysHoursMinutes(minutes).trim() || '0m'

export const getMaintenanceDataReportCards = (
  t: TFunction<['maintenance']>,
): MaintenanceDataReportCard[] => {
  const approximateTime = t('maintenance:requests.analytics.approximateTime')
  const forSelectedBuilding = t('maintenance:requests.analytics.forSelectedBuilding')
  const timeTo = t('maintenance:requests.analytics.timeTo')
  const openRequests = t('maintenance:requests.analytics.openRequests')
  const closedRequests = t('maintenance:requests.analytics.closedRequests')

  return [
    {
      description: approximateTime,
      formatValue: (data) => formatTime(data.avgTimeToAssign),
      title: `${timeTo} ${t('maintenance:requests.analytics.assign')}`,
    },
    {
      description: approximateTime,
      formatValue: (data) => formatTime(data.avgTimeToSchedule),
      title: `${timeTo} ${t('maintenance:requests.analytics.schedule')}`,
    },
    {
      description: approximateTime,
      formatValue: (data) => formatTime(data.avgTimeToClose),
      title: `${timeTo} ${t('maintenance:requests.analytics.complete')}`,
    },
    {
      description: forSelectedBuilding,
      formatValue: (data) => String(data.totalOpen),
      title: `${openRequests} (${t('maintenance:requests.analytics.active')})`,
    },
    {
      description: forSelectedBuilding,
      formatValue: (data) => String(data.totalPending),
      title: `${openRequests} (${t('maintenance:requests.analytics.pending')})`,
    },
    {
      description: forSelectedBuilding,
      formatValue: (data) => String(data.totalScheduled),
      title: `${openRequests} (${t('maintenance:requests.analytics.scheduled')})`,
    },
    {
      description: forSelectedBuilding,
      formatValue: (data) => String(data.totalClosed),
      title: `${closedRequests} (${t('maintenance:requests.analytics.inactive')})`,
    },
  ]
}
